/**
 * @author aldo-maciel
 */
import {Schema} from 'simpli-web-sdk'
import ReportsIRouteIndicatorResponse from '@/model/response/ReportsIRouteIndicatorResponse'
import Endereco from '@/model/resource/Endereco'

export default (model: ReportsIRouteIndicatorResponse): Schema => ({
  enderecoEntrega: {
    content:
      (model.endereco && Endereco.stringified(model.endereco))
      || model.destinatario && Endereco.stringified(model.destinatario.endereco),
  },
  destNumero: {
    content: model.currentNro,
  },
  destMunicipio: {
    content: model.destinatario && model.destinatario.endereco.cidade,
  },
  destEstado: {
    content: model.destinatario && model.destinatario.endereco.uf,
  },
  destPais: {
    content: null,
  },
  destCep: {
    content: model.destinatario && model.destinatario.endereco.cep,
  },
  destLatitude: {
    content: model.destinatario && model.destinatario.endereco.latitude,
  },
  destLongitude: {
    content: model.destinatario && model.destinatario.endereco.longitude,
  },
  pesoEntrega: {
    content: null,
  },
  volumeEntrega: {
    content: null,
  },
  valorMonetarioEntrega: {
    content: null,
  },
  duracaoEntrega: {
    content: null,
  },
  destNome: {
    content: model.destinatario && model.destinatario.nome,
  },
  destTelefone: {
    content: model.destinatario && model.destinatario.telefone,
  },
  danfe: {
    content: model.danfe ? ` ${ model.danfe } ` : '',
  },
  nroNotaFiscal: {
    content: model.nroNotaFiscal,
  },
  destDocument: {
    content: model.destinatario && model.destinatario.cpfCnpj,
  },
  emitNome: {
    content: model.embarcador && (model.embarcador.responsavel || { razaoSocial: null }).razaoSocial,
  },
  emitDocument: {
    content: model.embarcador && (model.embarcador.responsavel || { cnpj: null }).cnpj,
  },
  nomeTransportador: {
    content: (model.transportador || { responsavel: { razaoSocial: null } }).responsavel.razaoSocial,
  },
  docTransportador: {
    content: (model.transportador || { responsavel: { cnpj: null } }).responsavel.cnpj,
  },
  destinatarioInicioAtendimento: {
    content: null,
  },
  destinatarioFimAtendimento: {
    content: null,
  },
})
